import React from 'react';

function DataLvTds({ arr, indexNo, title, inputType = 'text', onChange, uneditableCond = (index) => { return false; } }) {
    const defalutValue = inputType === 'number' ? 0 : '';
    if (inputType == 'checkbox') {
        return (
            <React.Fragment>
                {
                    arr.map((_, index) => {
                        return (
                            <td colSpan={indexNo[index]} key={`${title}_${index}`}>
                                <input type={inputType} checked={arr[index]} value={!arr[index]} onChange={e => onChange(e, title, index)} disabled={uneditableCond(index)} />
                            </td>
                        );
                    })
                }
            </React.Fragment>
        );
    } else {
        return (
            <React.Fragment>
                {
                    arr.map((_, index) => {
                        if (uneditableCond(index)) {
                            return (
                                <td colSpan={indexNo[index]} key={`${title}_${index}`} className='uneditable'>
                                    {/* <input type={inputType} value={arr[index] ?? defalutValue} onChange={e => onChange(e, title, index)} min={1} /> */}
                                    <p>{arr[index]}</p>
                                </td>
                            );
                        } else {
                            return (
                                <td colSpan={indexNo[index]} key={`${title}_${index}`}>
                                    <input type={inputType} value={arr[index] ?? defalutValue} onChange={e => onChange(e, title, index)} min={1} />
                                </td>
                            );
                        }
                    })
                }
            </React.Fragment>
        );
    }
}

export default DataLvTds;